exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-1911b823]{position:fixed;height:64px;width:100%;z-index:90001;top:0;left:0;background:#ffe546}.header__logo[data-v-1911b823]{display:table;margin:20px auto 0}.header__logo img[data-v-1911b823]{max-width:152px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1911b823","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ChounDiary/partials/HeaderChoun.vue
// module id = CJGf
// module chunks = 0